import axiosInstance from "./AxiosInstance";

// ✅ Fetch all form fields
export const getAllFormFields = async () => {
  try {
    const response = await axiosInstance.get("api/all-form-fields");
    return response.data;
  } catch (error) {
    console.error("Error fetching form fields:", error);
    throw error;
  }
};

// ✅ Update all form fields
export const updateAllFormFields = async (preferences) => {
  try {
    const response = await axiosInstance.post("api/update/all-form-fields", {
      preferences,
      create_my_plan: false,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating form fields:", error);
    throw error;
  }
};

export const updateWeeklyCheckIn = async (data) => {
  try {
    const response = await axiosInstance.post("api/weekly-tracking/save", data);
    return response?.data;
  } catch (error) {
    console.error("Error updating form fields:", error);
    throw error;
  }
};

export const updateMedicalFormFields = async (preferences) => {
  try {
    const response = await axiosInstance.post("api/update/all-form-fields", {
      preferences: {
        ...preferences,
        dailyCalorieAdjustment: (
          preferences["targetDailyCalories"] -
          preferences["maintenanceCalories"]
        ).toString(),
        startingWeight: preferences?.weight,
        startingWeightUnit: preferences?.weightUnit,
        startingBodyFatPercentage:preferences?.bodyFatPercentage,
        startingWaistCircumference:preferences?.waistCircumference,
        startingHeight:preferences?.height,
      },
      is_medical_pref_completed: 0,
      create_my_plan: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating medical form fields:", error);
    throw error;
  }
};
